window.htmx = require('htmx.org');
import { nossFilter } from 'helper/filter';

document.body.addEventListener('htmx:afterSwap', function(evt) {
    if (window.lazyLoadInstance) {
        window.lazyLoadInstance.update();
    }
});

document.body.addEventListener('htmx:beforeRequest', function(evt) {
    let containerElement;
    if (evt.target.hasAttribute('hx-container')) {
        containerElement = evt.target;
    }
    else {
        containerElement = evt.target.closest('[hx-container]');
    }

    if (containerElement.querySelector('[hx-clear]') !== undefined) {
        containerElement.querySelector('[hx-clear]').innerHTML = '';
    }

    containerElement.setAttribute('hx-loading', '');

    setTimeout(function(){
        if (containerElement.hasAttribute('hx-loading')) {
            containerElement.classList.add('hx-loading');
        }
    }, 500);

});
document.body.addEventListener('htmx:afterRequest', function(evt) {
    let containerElement;
    if (evt.target.hasAttribute('hx-container')) {
        containerElement = evt.target;
    }
    else {
        containerElement = evt.target.closest('[hx-container]');
    }

    let loadingElement = containerElement.querySelector('.itemsload');
    if (loadingElement) {
        if (loadingElement.childNodes.length !== 0) {
            containerElement.querySelector('.items').remove();
            loadingElement.classList.add('items');
            loadingElement.classList.remove('itemsload');
            let newDiv = document.createElement('div');
            newDiv.classList.add('itemsload');
            containerElement.querySelector('.items-container').appendChild(newDiv);
        }
    }
    containerElement.removeAttribute('hx-loading');
    containerElement.classList.remove('hx-loading');
    if (window.htmxloaded) {
        if (window.htmxloaded.includes(containerElement)) {
            window.scroll(0, containerElement.offsetTop);
        }
        window.htmxloaded.push(containerElement);
    }
    window.htmxloaded = [];

    if (containerElement.hasAttribute('hx-triggerfilter')) {
        nossFilter();
    }
});